var AddressTypes;
(function (AddressTypes) {
  AddressTypes["BILLING"] = "billingAddress";
  AddressTypes["SHIPPING"] = "shippingAddress";
  AddressTypes["CUSTOMER"] = "customerAddress";
  AddressTypes["SPECIFIC"] = "specific";
})(AddressTypes || (AddressTypes = {}));
export default AddressTypes;